.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 24px;
  padding: 28px 32px 20px;
}

.text { min-width: 0; }

.title {
  margin: 0;
  font-size: 26px;
  font-weight: 650;
  line-height: 1.2;
  letter-spacing: -.01em;
  color: var(--text);
}

.subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--text2);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 699px) {
  .header { padding: 20px 16px 14px; }
  .title { font-size: 22px; }
}
